import 'babel-polyfill'
import Vue from 'vue'
import VueTouch from 'vue-touch'
import Axios from 'axios'
import VueMaterial from 'vue-material'
import VeeValidate from 'vee-validate'
import VueTheMask from 'vue-the-mask'
import 'vue-material/dist/vue-material.css'
import i18n from './i18n'
import {Calendar, DateRange} from 'vue-date-range'
import Capitalize from './filters/Capitalize'
import Uppercase from './filters/Uppercase'
import Lowercase from './filters/Lowercase'
import utils from '@/utils/utils.js'
import moment from 'moment-timezone'
import UUID from 'vue-uuid'
import security from '@/security'
import flatPickr from 'vue-flatpickr-component'
import VirtualList from 'vue-virtual-scroll-list'
import analytics from '@/utils/analytics'

// set default css
import '@/assets/base.scss'
import 'flatpickr/dist/flatpickr.css'

import App from './App'
import router from './router'
import store from './store'

// uses
Vue.use(VueMaterial)

Vue.use(VeeValidate)
Vue.use(VueTouch)
Vue.use(UUID)
Vue.use(VueTheMask)
Vue.use(flatPickr)

// components

Vue.component('calendar', Calendar)
Vue.component('dateRange', DateRange)

Vue.component('advancedSelect', () => import('./components/AdvancedSelect'))
Vue.component('collapse', () => import('./components/Collapse'))


Vue.component('usersItem', () => import('./components/Autocomplete/UsersItem'))
Vue.component('search', () => import('./components/Autocomplete/Search'))
Vue.component('virtual-list', VirtualList)

// filters
Vue.filter('capitalize', Capitalize)
Vue.filter('uppercase', Uppercase)
Vue.filter('lowercase', Lowercase)

// Axios
Vue.prototype.$http = Axios
Axios.defaults.baseURL = process.env.VUE_APP_URL_SERVER_BASE
Axios.defaults.headers.common['timeZone'] = moment.tz.guess()
Axios.defaults.headers.get['Pragma'] = 'no-cache'
Axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store'

Vue.config.productionTip = false

Vue.prototype.$moment = moment

// i18n
const language = window.navigator.userLanguage || window.navigator.language
i18n.setLanguage(language)
Vue.prototype.$languages = () => {
  return i18n
}

Vue.prototype.$showMessage = async (obj) => {
  await store.dispatch('Global/showMessage', obj)
}

Vue.prototype.$hideMessage = async () => {
  await store.dispatch('Global/hideMessage')
}

Vue.prototype.$showLoading = () => {
  store.dispatch('Global/showLoading')
}

Vue.prototype.$hideLoading = () => {
  store.dispatch('Global/hideLoading')
}

Vue.prototype.$focusMdDialog = () => {
  setTimeout(() => {
    var all = document.getElementsByTagName('input')
    for (let i = 0; i < all.length; i++) {
      let parentElement = all[i].parentElement
      let focused = false
      while (parentElement !== null) {
        if (parentElement.className === 'md-dialog-content') {
          all[i].focus()
          focused = true
          break
        }
        parentElement = parentElement.parentElement
      }
      if (focused) {
        break
      }
    }
  }, 500)
}

Vue.prototype.$focusField = (index) => {
  setTimeout(() => {
    var all = document.getElementsByTagName('input')
    all[index].focus()
  }, 500)
}

Vue.prototype.$searchBy = (items, term, field) => {
  if (!field) {
    return items.filter(item => utils._toLower(item).indexOf(utils._toLower(term)) >= 0)
  }

  if (term) {
    return items.filter(item => utils._toLower(item[field]).indexOf(utils._toLower(term)) >= 0)
  }

  return items
}

Axios.interceptors.response.use(response => {
  return response
}, async error => {
  if (error && error.response && error.response.status) {
    const status = typeof error === 'object' ? (error.response && error.response.status ? error.response.status : 0) : error
    if (status === 401) {
      // desloga e redireciona pra tela de login
      store.dispatch('Auth/signout')
    } else if (status === 403) {
      store.dispatch('Global/showMessage', {message: 'accessDeniedError'})
    } else if (status === 503 || status === 429) {
      store.dispatch('Global/showMessage', {message: 'errorDefault'})
    } else if (status === 400) {
      store.dispatch('Global/showMessage', {message: 'errorBadRequest'})
    } else if (status === 409) {
      store.dispatch('Global/showMessage', {message: 'conflictError'})
    } else if (status === 415) {
      store.dispatch('Global/showMessage', {message: 'mediaError'})
    } else if (status !== 404 && status !== 422 && status >= 400) {
      store.dispatch('Global/showMessage', {message: 'unexpectedError'})
    }
  }
  return Promise.reject(error)
})

// Axios Interceptors
Axios.interceptors.request.use(async config => {
  // se tiver autenticado, adiciona access_token ao request
  let user = await security.getUser()
  if (user) {
    const authToken = user.access_token
    if (authToken) {
      config.headers.Authorization = `Bearer ${authToken}`
    }
  }
  return config
})

// Google Analytics
Vue.prototype.$analytics = analytics

/* eslint-disable no-new */

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
